import { motion } from 'motion/react';

interface SuggestionChipsProps {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
}

export function SuggestionChips({ suggestions, onSelect }: SuggestionChipsProps) {
  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-text-muted">Quick actions</h3>
      <motion.div
        className="flex flex-wrap gap-2"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, staggerChildren: 0.05 }}
      >
        {suggestions.map((suggestion, index) => (
          <motion.button
            key={suggestion}
            onClick={() => onSelect(suggestion)}
            className="badge-info hover:bg-blue-500/20 cursor-pointer px-3 py-1.5 text-sm"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.2, delay: index * 0.05 }}
          >
            {suggestion}
          </motion.button>
        ))}
      </motion.div>
    </div>
  );
}